import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../types/models';

interface UsersState {
  users: User[];
  isTargetsLoading: boolean;
  isDashboardsLoading: boolean;
  isCustomersLoading: boolean;
  isUsersLoading: boolean;
  error: boolean;
  errorMessage: string;
}

const initialState: UsersState = {
  users: [],
  isTargetsLoading: false,
  isDashboardsLoading: false,
  isCustomersLoading: false,
  isUsersLoading: false,
  error: false,
  errorMessage: ''
};

// M6: RTK createSlice.
const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    requestUsers(state) {
      return { ...state, isUsersLoading: true, error: false, errorMessage: '' };
    },
    requestUsersError(state, action: PayloadAction<{ errorMessage?: string }>) {
      return { ...state, isUsersLoading: false, error: true, errorMessage: action.payload.errorMessage || '_empty_users_error_' };
    },
    requestUsersSuccess(state, action: PayloadAction<User[]>) {
      return { ...state, isUsersLoading: false, error: false, errorMessage: '', users: action.payload };
    },
  },
});

export const { requestUsers, requestUsersError, requestUsersSuccess } = usersSlice.actions;
export default usersSlice.reducer;
